import axios, { AxiosRequestConfig } from 'axios';
import IResponse from '../interfaces/IResponse';
import { ISlide } from '../interfaces/ISlide';
import ApiHelper from './ApiHelper';
import { baseURL } from '../config';

const BASE_URL = `${baseURL}api/imageSlider`;

interface IGetAllImages extends IResponse {
    images: ISlide[] | null,
}

const getAllImages = async (): Promise<IGetAllImages> => {
    const url = `${BASE_URL}`

    try {
        const res = await axios.get(url);

        const resoult = {
            ok: true,
            status: res.status,
            message: 'Pobrano slajdy',
            images: res.data.images
        }

        return resoult;

    } catch (error) {

        let message = 'Nie pobrano slajdów'
        let status = 400

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 403) message = 'Nie można pobrać slajdów'
            if (error.response.status === 404) message = 'Nie znaleziono slajdów'
        }

        return {
            message,
            status,
            ok: false,
            images: null,
        }
    }
}


interface IGetAllImagesAdmin extends IResponse {
    images: ISlide[] | null,
}

const getAllImagesAdmin = async (): Promise<IGetAllImagesAdmin> => {
    const url = `${BASE_URL}/admin`
    const config: AxiosRequestConfig = {
        headers: ApiHelper.createHeader(),
    };

    try {
        const res = await axios.get(url, config);

        const resoult = {
            ok: true,
            status: res.status,
            message: 'Pobrano slajdy',
            images: res.data.images
        }

        return resoult;

    } catch (error) {

        let message = 'Nie pobrano slajdów'
        let status = 400

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 403) message = 'Nie można pobrać slajdów'
            if (error.response.status === 404) message = 'Nie znaleziono slajdów'
        }

        return {
            message,
            status,
            ok: false,
            images: null,
        }
    }
}


interface IAddImages extends IResponse {
    newImage: ISlide | null,
}

export interface IAddSlideDto {
    image: File;
    link: string;
    publishedAt?: Date | null;
    expiresAt?: Date | null;
    deletedAt?: Date | null;
    name?: string;
}

const addImage = async (data: IAddSlideDto): Promise<IAddImages> => {
    const url = BASE_URL;
    const config: AxiosRequestConfig = {
        headers: ApiHelper.createHeaderForFiles(),
    };

    const formData = new FormData();
    formData.append('image', data.image);
    formData.append('link', data.link);
    if (data.publishedAt) formData.append('publishedAt', data.publishedAt.toISOString());
    if (data.expiresAt) formData.append('expiresAt', data.expiresAt.toISOString());
    if (data.deletedAt) formData.append('deletedAt', data.deletedAt.toISOString());
    if (data.name) formData.append('name', data.name);

    try {
        const res = await axios.post(url, formData, config);

        return {
            ok: true,
            status: res.status,
            message: 'Dodano slajd',
            newImage: res.data.newImage
        };
    } catch (error) {
        let message = 'Nie dodano slajdu';
        let status = 400;

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 403) message = 'Nie można dodać slajdu';
            if (error.response.status) status = error.response.status;
        }

        return {
            message,
            status,
            ok: false,
            newImage: null
        };
    }
};

interface IDeleteImage extends IResponse { }

const deleteImage = async (_id: string): Promise<IDeleteImage> => {
    const url = `${BASE_URL}/${_id}`;
    const config: AxiosRequestConfig = {
        headers: ApiHelper.createHeader()
    }

    try {
        const res = await axios.delete(url, config)

        const resoult = {
            ok: true,
            status: res.status,
            message: 'Usunięto zdjęcie',
        }

        return resoult
    } catch (error) {

        let message = 'Nie usunięto zdjęcia'
        let status = 400

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 403) message = 'Nie możesz tego zrobić'
            if (error.response.status === 404) message = 'Nie znaleziono zdjęcia'
            if (error.response.status) status = error.response.status
        }

        return {
            message,
            ok: false,
            status,
        }
    }
}


interface IUpdateImagesOrder extends IResponse {

}

const updateImagesOrder = async (ids: string[]): Promise<IUpdateImagesOrder> => {
    const url = `${BASE_URL}/updateImagesOrder`;
    const config: AxiosRequestConfig = {
        headers: ApiHelper.createHeader()
    }

    try {
        const res = await axios.post(url, ids, config)

        const resoult = {
            ok: true,
            status: res.status,
            message: 'Zaktualizowano kolejność zdjęć',
        }

        return resoult
    } catch (error) {

        let message = 'Nie zaktualizowano kolejności zdjęć'
        let status = 400

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 403) message = 'Nie możesz tego zrobić'
            if (error.response.status === 404) message = 'Nie znaleziono zdjęć'
            if (error.response.status) status = error.response.status
        }

        return {
            message,
            ok: false,
            status,
        }
    }
}


interface IEditImageDates extends IResponse {
    image?: ISlide | null;
}

interface IEditImageDatesDto {
    _id: string;
    publish?: string | null;
    expire?: string | null;
    remove?: string | null;
}

const editImageDates = async (data: IEditImageDatesDto): Promise<IEditImageDates> => {
    const url = `${BASE_URL}/editImageDates`;
    const config: AxiosRequestConfig = {
        headers: ApiHelper.createHeader()
    };

    try {
        const res = await axios.patch(url, data, config);

        return {
            ok: true,
            status: res.status,
            message: 'Zaktualizowano daty slajdu',
            image: res.data.image
        };
    } catch (error) {
        let message = 'Nie zaktualizowano dat slajdu';
        let status = 400;

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 403) message = 'Nie możesz tego zrobić';
            if (error.response.status === 404) message = 'Nie znaleziono slajdu';
            if (error.response.status) status = error.response.status;
        }

        return {
            message,
            ok: false,
            status,
            image: null
        };
    }
};


interface ISetImageLink extends IResponse {
    image?: ISlide | null;
}

const setImageLink = async (_id: string, link: string): Promise<ISetImageLink> => {
    const url = `${BASE_URL}/setImageLink`;
    const config: AxiosRequestConfig = {
        headers: ApiHelper.createHeader()
    };

    try {
        const res = await axios.patch(url, { _id, link }, config);

        return {
            ok: true,
            status: res.status,
            message: 'Zaktualizowano link slajdu',
            image: res.data.image
        };
    } catch (error) {
        let message = 'Nie zaktualizowano linku slajdu';
        let status = 400;

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 403) message = 'Nie możesz tego zrobić';
            if (error.response.status === 404) message = 'Nie znaleziono slajdu';
            if (error.response.status) status = error.response.status;
        }

        return {
            message,
            ok: false,
            status,
            image: null
        };
    }
}


const imageSliderController = {
    getAllImages,
    getAllImagesAdmin,
    addImage,
    deleteImage,
    updateImagesOrder,
    editImageDates,
    setImageLink,
};

export default imageSliderController;